import { useState, useCallback } from 'react';

export default function useSolarRadiation(emissionPointId) {
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!emissionPointId) return;
    setLoading(true);
    try {
      const res = await fetch(`/api/emission-points/${emissionPointId}/solar-radiation`);
      const data = await res.json();

      const filled = Array.from({ length: 24 }, (_, hour) => {
        const existing = data.find(r => r.hour === hour);
        return {
          hour,
          radiation: typeof existing?.radiation === "number" ? existing.radiation : 0.0
        };
      });

      setValues(filled);
      setError(null);
    } catch (err) {
      console.error("Failed to load solar radiation", err);
      setValues(Array.from({ length: 24 }, (_, hour) => ({ hour, radiation: 0.0 })));
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [emissionPointId]);

  const save = useCallback(async () => {
    if (!emissionPointId) return;
    setLoading(true);
    try {
      const res = await fetch(`/api/emission-points/${emissionPointId}/solar-radiation`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setError(null);
    } catch (err) {
      console.error("Failed to save solar radiation", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [emissionPointId, values]);

  return { values, setValues, load, save, loading, error };
}
